module.exports = __webpack_public_path__ + "img/Toppone_SX.5c1d8c83.png";